import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { LargeOrderPromo, LargeOrderPromoCard } from '@/models/cms';
import CmgButton from '@/components/CmgButton/CmgButton.vue';
import CmgLargeOrderPromoCard from '@/components/CmgLargeOrderPromo/CmgLargeOrderPromoCard/CmgLargeOrderPromoCard.vue';
import { ColorStyle, BackgroundColorStyle } from '@/models/util';
import { ui } from '@/constants';

@Component({
  name: 'CmgLargeOrderPromo',
  components: {
    CmgButton,
    CmgLargeOrderPromoCard
  }
})
export default class CmgLargeOrderPromo extends Vue {

  @Prop({ required: true, type: Object })
  largeOrderPromo!: LargeOrderPromo;

  @Prop({ type: Object })
  groupOrderData?: LargeOrderPromoCard;

  @Prop({ type: Object })
  cateringData?: LargeOrderPromoCard;

  get groupOrderIndex(): number {
    // Component is set up to always put group order first
    return this.groupOrderData ? 1 : 0;
  }

  get cateringIndex(): number {
    // Component is set up put catering second if group order exists
    return this.cateringData ? (this.groupOrderData ? 2 : 1) : 0;
  }

  get backgroundImageUrl(): string | undefined {
    const isMobile = this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
    return isMobile ? this.largeOrderPromo.mobileBackgroundImageUrl : this.largeOrderPromo.desktopBackgroundImageUrl;
  }

  get backgroundColor(): BackgroundColorStyle {
    const isMobile = this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
    const color = (isMobile ? this.largeOrderPromo.mobileBackgroundColor : this.largeOrderPromo.desktopBackgroundColor) || 'white';
    return { 'background-color': color };
  }

  get preTitle(): string | undefined {
    return this.largeOrderPromo.preTitle;
  }

  get preTitleColor(): ColorStyle {
    return { color: this.largeOrderPromo.preTitleColor || 'white' };
  }

  get title(): string | undefined {
    return this.largeOrderPromo.title;
  }

  get titleColor(): ColorStyle {
    return { color: this.largeOrderPromo.titleColor || 'white' };
  }
}
